import { Center, Text, Switch, Flex } from '@chakra-ui/react';
import { memo } from 'react';
import { Card } from '@halo/ui-chat-react';

interface GroupItemProps {
  icon: React.ReactNode;
  title: string;
  extra?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  onClick?: () => void;
}

const GroupItem = ({
  icon,
  title,
  extra = false,
  checked = false,
  onChange,
  onClick,
}: GroupItemProps) => {
  return (
    <Card>
      <Flex align="center" justify="space-between" cursor="pointer" onClick={onClick}>
        <Flex align="center" gap="2.5">
          {icon && (
            <Center w={'6.5'} h={'6.5'}>
              {icon}
            </Center>
          )}
          <Text fontSize="sm" fontWeight="medium">
            {title}
          </Text>
        </Flex>
        {extra && (
          <Switch.Root
            checked={checked}
            onCheckedChange={(e) => onChange?.(e.checked)}
            onClick={(e) => e.stopPropagation()}
          >
            <Switch.HiddenInput />
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
          </Switch.Root>
        )}
      </Flex>
    </Card>
  );
};

const MemoizedGroupItem = memo(GroupItem);
export { MemoizedGroupItem as GroupItem };
